module.exports = __webpack_public_path__ + "static/media/Tiger Woman.b70a4a9c.jpg";